import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/7dd235b1-911e-47df-b605-25020d18ce34/images/6a228149b2f48b31000b9886b471be15f2968439907659a82abfdb8e6374b9ba.jpeg",
  healer: "https://static.prod-images.emergentagent.com/jobs/7dd235b1-911e-47df-b605-25020d18ce34/images/d635cfbb9d0c236ca10a3ab8d311ad7ffd46e804b5a5241bd413bbc4698a57f7.jpeg",
};

export const SERVICES = ["Spiritual Readings", "Energy Healing", "Starseed Guidance", "Teaching / Classes"];

export const errorText = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return "Please check the form — " + d.map((x) => x.loc?.slice(-1)[0]).join(", ");
  return d || "Something went wrong. Please try again.";
};

export const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const api = axios.create({ baseURL: API });
